export const AUTH_BASE_URL =
  process.env.REACT_APP_AUTH_BASE_URL ||
  "https://api.g9eduinternational.com/auth";

export const USER_BASE_URL =
  process.env.REACT_APP_USER_BASE_URL ||
  "https://api.g9eduinternational.com/user";

export const VERSION = process.env.REACT_APP_VERSION || "v1";

export const APP_VERSION = process.env.REACT_APP_APP_VERSION || "1.0.2";

export const apiClientHeaders = (extra = {}) => ({
  ...extra,
  "app-version": APP_VERSION,
  "app-os": "web",
});
